import {
  HIDDEN_CLAIMS_SECTIONS,
  HIDDEN_GOLDEN_RECORDS_SECTIONS,
  SECTION_CONFIG,
  REQUIRED_FIELDS_BY_ENTITY,
} from './consts';

const blankSchema = schema => schema.reduce((acc, val) => ({ ...acc, [val.columnKey]: 'Ignored' }), {});

const filterSection = hiddenSections =>
  SECTION_CONFIG.reduce((acc, curr) => {
    !hiddenSections.includes(curr.type) && acc.push(curr);
    return acc;
  }, []);

const goldenRecordSections = filterSection(HIDDEN_GOLDEN_RECORDS_SECTIONS);

const claimSections = filterSection(HIDDEN_CLAIMS_SECTIONS);

const validateRequiredFields = (entityType, overrideAttributes) => {
  const requiredFields = REQUIRED_FIELDS_BY_ENTITY[entityType];
  if (!requiredFields) return null;

  const missingFields = requiredFields.filter(field => !overrideAttributes[field]);
  if (missingFields.length === 0) return null;

  const fieldNames = missingFields.map(field => field.replace(/_/g, ' ')).join(', ');
  return `${fieldNames} ${missingFields.length === 1 ? 'is' : 'are'} required to create a ${entityType}.`;
};

export { blankSchema, goldenRecordSections, claimSections, validateRequiredFields };
